import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ScreenService } from '../../shared/services/screen/screen.service';

@Component({
  selector: 'app-projects',
  standalone: true,
  imports: [
    TranslatePipe,
    CommonModule
],
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css'],
})
export class ProjectsComponent implements OnInit {
  projects: any[] = [];
  currentIndex = 0;
  isMobile = false;
  private destroyRef = inject(DestroyRef);

  constructor(
    private translate: TranslateService,
    private screenService: ScreenService
  ) {}

  ngOnInit(): void {
    this.loadProjects();

    this.screenService.isMobile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isMobile) => {
      this.isMobile = isMobile;
    });

    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.loadProjects();
    });
  }

  private loadProjects(): void {
    this.translate.get('projects.list').subscribe((res) => {
      this.projects = res;
      this.currentIndex = 0;
    });
  }

  get hasProjects(): boolean {
    return Array.isArray(this.projects) && this.projects.length > 0;
  }

  get currentProject(): any | null {
    return this.hasProjects ? this.projects[this.currentIndex] : null;
  }

  get canPrev(): boolean {
    return this.currentIndex > 0;
  }

  get canNext(): boolean {
    return this.hasProjects && this.currentIndex < this.projects.length - 1;
  }

  prev(): void {
    if (this.canPrev) {
      this.currentIndex -= 1;
    }
  }

  next(): void {
    if (this.canNext) {
      this.currentIndex += 1;
    }
  }

  openDemo(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  setIndex(index: number): void {
    if (!this.hasProjects || index === this.currentIndex) {
      return;
    }

    this.currentIndex = index;
  }
}

